import { render, staticRenderFns } from "./invoicing.vue?vue&type=template&id=2ad331c5"
import script from "./invoicing.vue?vue&type=script&lang=js"
export * from "./invoicing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports